import axios from "axios";
const API = ''
export const fetchAllAgents = () => axios.get(API);